import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  ApprovalMasterDeleteInput,
  ApprovalMasterModel,
  ApprovalMasterMutationInput,
  ApprovalMasterUpdateInput,
} from './model';

export function useCreateApprovalMaster(
  options?: UseMutationOptions<
    ApiResult<ApprovalMasterModel>,
    ApiError,
    ApprovalMasterMutationInput
  >,
): UseMutationResult<
  ApiResult<ApprovalMasterModel>,
  ApiError,
  ApprovalMasterMutationInput
> {
  return useMutation<
    ApiResult<ApprovalMasterModel>,
    ApiError,
    ApprovalMasterMutationInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: 'approvals',
      method: 'POST',
      classType: ApprovalMasterModel,
      body,
    });
  }, options);
}

export function useUpdateApprovalMaster(
  options?: UseMutationOptions<
    ApiResult<ApprovalMasterModel>,
    ApiError,
    ApprovalMasterUpdateInput
  >,
): UseMutationResult<
  ApiResult<ApprovalMasterModel>,
  ApiError,
  ApprovalMasterUpdateInput
> {
  return useMutation<
    ApiResult<ApprovalMasterModel>,
    ApiError,
    ApprovalMasterUpdateInput
  >(async function (body) {
    return await MutationFetchFunction({
      url: `approvals/${body.approvalId}`,
      method: 'PUT',
      classType: ApprovalMasterModel,
      body: body.body,
    });
  }, options);
}

export function useDeleteApprovalMaster(
  options?: UseMutationOptions<
    { message: string },
    ApiError,
    ApprovalMasterDeleteInput
  >,
): UseMutationResult<{ message: string }, ApiError, ApprovalMasterDeleteInput> {
  return useMutation<{ message: string }, ApiError, ApprovalMasterDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `approvals/${body.approvalId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}
